module.exports = __webpack_public_path__ + "img/40bc39a.png";